import styles from "./ScheduleDescription.module.css";

const ScheduleDescriptionModule = ({ module }) => {
  const { name, color, slug, desc_short } = module;
  return (
    <>
      <div className="col-sm-6 col-lg-4 mb-2">
        <a href={`/module/${slug}`}>
          <div className={styles.content}>
            <div
              style={{ backgroundColor: color }}
              className={styles.legend}
            ></div>
            <div>
              <h2 className="m-0">{name}</h2>
              <p className="m-0">{desc_short}</p>
            </div>
          </div>
        </a>
      </div>
    </>
  );
};

export const ScheduleDescription = ({ moduleList }) => {
  return (
    <>
      <div className={styles.wrapper}>
        <h1 className="py-4 m-0 text-center">Обозначения</h1>
        <div className="col-12 mx-auto row">
          {moduleList.map((item) => {
            return <ScheduleDescriptionModule key={item.order} module={item} />;
          })}
        </div>
      </div>
    </>
  );
};
